import HeaderComponent from "./HeaderComponenet";
import SideBar from "./SideBar";
import React from "react";
import Container from "react-bootstrap/Container";
import { Route, Routes } from "react-router-dom";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
// import flight
import FlightSearchPage from "../../Modules/FlightDoc/FlightSearchPage";
import FlightDetailPage from "../../Modules/FlightDoc/FlightDetailPage";
import FlightIssuePage from "../../Modules/FlightDoc/FlightIssuePage";
import FlightReservePage from "../../Modules/FlightDoc/FlightReservePage";
import FlightRevalidatePage from "../../Modules/FlightDoc/FlightRevalidatePage";
import FlightTicketPage from "../../Modules/FlightDoc/FlightTicketPage";
import FlightCancelPage from "../../Modules/FlightDoc/FlightCancelPage";
import RefundByRefrence from "../../Modules/FlightDoc/RefundByRefrence";
import RefundByTickets from "../../Modules/FlightDoc/RefundByTickets";
import RefundStatus from "../../Modules/FlightDoc/RefundStatus";
import Revalidate from "../../Modules/FlightDoc/Revalidate";

// import hotel
import HotelSearchPage from "../../Modules/HotelDoc/HotelSearchPage";
import HotelTicketPage from "../../Modules/HotelDoc/HotelTicketPage";
import HotelCancelPage from "../../Modules/HotelDoc/HotelCancelPage";
import HotelIssuePage from "../../Modules/HotelDoc/HotelIssuePage";
import HotelDetailPage from "../../Modules/HotelDoc/HotelDetailPage";
import HotelReservePage from "../../Modules/HotelDoc/HotelReservePage";
import HotelRevalidatePage from "../../Modules/HotelDoc/HotelRevalidatePage";

// import train
import TrainSearchPage from "../../Modules/TrainDoc/TrainSearchPage";
import TrainTicketPage from "../../Modules/TrainDoc/TrainTicketPage";
import TrainCancelPage from "../../Modules/TrainDoc/TrainCancelPage";
import TrainIssuePage from "../../Modules/TrainDoc/TrainIssuePage";
import TrainReservePage from "../../Modules/TrainDoc/TrainReservePage";

// import Bus
import BusSearchPage from "../../Modules/BusDoc/BusSearchPage";
import BusTicketPage from "../../Modules/BusDoc/BusTicketPage";
import BusIssuePage from "../../Modules/BusDoc/BusIssuePage";
import BusReservePage from "../../Modules/BusDoc/BusReservePage";
import BusDetailPage from "../../Modules/BusDoc/BusDetailPage";
import BusRefundPage from "../../Modules/BusDoc/BusRefundPage";



function layout(props) {
  return (
    <>
      <HeaderComponent />
      <Container fluid>
        <Row>
          <Col sm={2} className="sidebar grey">
            <SideBar />
          </Col>
          <Col sm={10} className="main-body">
            <Routes>
            <Route exact path="/" element={<FlightSearchPage />}></Route>
              <Route exact path="FlightSearchPage" element={<FlightSearchPage />}></Route>
              <Route exact path="FlightDetailPage" element={<FlightDetailPage />}></Route>
              <Route exact path="FlightIssuePage" element={<FlightIssuePage />}></Route>
              <Route exact path="FlightReservePage" element={<FlightReservePage />}></Route>
              <Route exact path="FlightRevalidatePage" element={<FlightRevalidatePage />}></Route>
              <Route exact path="FlightTicketPage" element={<FlightTicketPage />}></Route>
              <Route exact path="FlightCancelPage" element={<FlightCancelPage />}></Route>
              <Route exact path="FlightRefundByRefrence" element={<RefundByRefrence />}></Route>
              <Route exact path="FlightRefundByTickets" element={<RefundByTickets />}></Route>
              <Route exact path="FlightRefundStatus" element={<RefundStatus />}></Route>
              <Route exact path="FlightRevalidate" element={<Revalidate />}></Route>
              
              <Route exact path="HotelSearchPage" element={<HotelSearchPage />}></Route>
              <Route exact path="HotelTicketPage" element={<HotelTicketPage />}></Route>
              <Route exact path="HotelCancelPage" element={<HotelCancelPage />}></Route>
              <Route exact path="HotelIssuePage" element={<HotelIssuePage />}></Route>
              <Route exact path="HotelDetailPage" element={<HotelDetailPage />}></Route>
              <Route exact path="HotelReservePage" element={<HotelReservePage />}></Route>
              <Route exact path="HotelRevalidatePage" element={<HotelRevalidatePage />}></Route>

              <Route exact path="TrainSearchPage" element={<TrainSearchPage />}></Route>
              <Route exact path="TrainTicketPage" element={<TrainTicketPage />}></Route>
              <Route exact path="TrainCancelPage" element={<TrainCancelPage />}></Route>
              <Route exact path="TrainIssuePage" element={<TrainIssuePage />}></Route>
              <Route exact path="TrainReservePage" element={<TrainReservePage />}></Route>

              <Route exact path="BusSearchPage" element={<BusSearchPage />}></Route>
              <Route exact path="BusTicketPage" element={<BusTicketPage />}></Route>
              <Route exact path="BusDetailPage" element={<BusDetailPage />}></Route>
              <Route exact path="BusIssuePage" element={<BusIssuePage />}></Route>
              <Route exact path="BusReservePage" element={<BusReservePage />}></Route>
              <Route exact path="BusRefundPage" element={<BusRefundPage />}></Route>
              
            </Routes>
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default layout;
